import {Component} from '@angular/core';

@Component({
  selector: 'app-instruction-icon',
  standalone: true,
  imports: [],
  templateUrl: './instruction-icon.component.html',
  styleUrl: './instruction-icon.component.css',
})
export class InstructionIconComponent {}
